module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "nucleicAcidDetail"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('div', {
    staticClass: "nucleicAcidDetailCon"
  }, [_c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('qrcode', {
    attrs: {
      "size": 100,
      "value": _vm.identityNo,
      "type": "img"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "10px",
      "font-size": "16px"
    }
  }, [_vm._v(_vm._s(_vm.identityNo))])], 1), _vm._v(" "), _c('group', [_c('cell', {
    attrs: {
      "title": "就诊院区",
      "value": _vm.hospitalAreaName,
      "border-intent": "false"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "就诊人",
      "value": _vm.patientName,
      "border-intent": "false"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "检验项目",
      "value": _vm.diagItemCname,
      "border-intent": "false"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "缴费状态",
      "value": _vm.sjfztCmc,
      "border-intent": "false"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "检验费用",
      "value": _vm.totalAmt + '元',
      "border-intent": "false"
    }
  }), _vm._v(" "), _c('cell', {
    attrs: {
      "title": "开单时间",
      "value": _vm.orderedDate,
      "border-intent": "false"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.sjfztCmc == '未计费'),
      expression: "sjfztCmc == '未计费'"
    }],
    staticStyle: {
      "box-sizing": "border-box",
      "position": "fixed",
      "bottom": "0px",
      "width": "100%"
    }
  }, [_c('x-button', {
    staticClass: "orangeBtn",
    staticStyle: {
      "border-radius": "0px"
    },
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sureClick($event)
      }
    }
  }, [_vm._v("去缴费")])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "head"
  }, [_c('h2', [_vm._v("核酸开单成功")]), _vm._v(" "), _c('p', [_vm._v("凭此页面即可到院检测")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4336a8f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/selfHelpFilingProject/nucleicAcidDetail.vue
// module id = vPzn
// module chunks = 7